export const faqItems = [
  {
    question: '黑料入口是什么？',
    answer: '黑料入口是一个专注于娱乐资讯和热点事件的内容聚合平台，为用户提供最新、最全的网红塌房、明星翻车、行业内幕等吃瓜内容。我们致力于为用户提供便捷可靠的资讯浏览体验，让你不错过任何一个热门吃瓜现场。',
  },
  {
    question: '黑料入口的内容来源是否可靠？',
    answer: '我们始终坚持内容的真实性和客观性。所有文章均来源于公开报道、网友投稿以及专业的调查团队。对于每一条信息，我们都会进行必要的核实，确保为用户提供有据可查的吃瓜内容。同时我们也会标注信息来源，方便用户自行查证。',
  },
  {
    question: '如何找到黑料入口的最新地址？',
    answer: '黑料入口的官方网址会定期更新以确保访问稳定。建议你将本站添加到浏览器收藏夹，或关注我们的社交媒体账号获取最新的地址更新通知。你也可以通过搜索引擎搜索"黑料入口"找到我们的官方网站。',
  },
  {
    question: '黑料入口是否收费？',
    answer: '黑料入口是一个完全免费的平台。所有内容均无需付费即可浏览，我们希望通过免费开放的方式让更多人能够及时获取最新资讯。本站不收取任何会员费或订阅费用。',
  },
  {
    question: '如何投稿或爆料？',
    answer: '如果你有独家内幕消息或有趣的黑料素材，欢迎通过我们的官方邮箱或社交媒体账号进行投稿。我们会对每一条投稿进行认真审核，保护投稿人的隐私安全。优质爆料一经采用，将获得优先展示和推荐。',
  },
  {
    question: '黑料入口的内容更新频率如何？',
    answer: '我们保持每日更新，每天至少有10篇以上的新内容发布。团队24小时关注各大平台热点动态，确保第一时间为用户带来最新、最热的吃瓜内容。热门事件发生后的最快响应时间不超过30分钟。',
  },
];